import React from 'react';

import LeadGuarantee from 'app/shared/containers/LearnMoreLeadGuaranteePage/components/LeadGuarantee';

import { StyledContainer } from './StyledComponents';

const PaidInclusionValuePropModal = () => (
    <StyledContainer className="PaidInclusionValuePropModal">
        <LeadGuarantee />
    </StyledContainer>
);

export default PaidInclusionValuePropModal;
